import React from 'react'

// STYLES
import withAppBarStyles from './AppBar.style'

// COMPONENTS
import AppBar from '@material-ui/core/AppBar'
import Toolbar from '@material-ui/core/Toolbar'
import LogoData from '../app-logo/logo-data'
import { ButtonOutlined } from '../app-button/button'
import { translate } from 'react-i18next'

const MUIAppBar = ({ classes, hideLogin, islogin, hideBtn, t }) => {
  const EnterLink = () => (
    <a href={islogin ? '/logout' : '/login'} className={classes.link}>
      <ButtonOutlined
        style={{ marginLeft: 30 }}
        color="primary"
        text={
          islogin
            ? t('appBar.logOut', { framework: 'react-i18next' })
            : t('appBar.login', { framework: 'react-i18next' })
        }
      />
    </a>
  )

  const btnAction = !hideBtn && (
    <div className={classes.buttonGroup}>
      <EnterLink />
    </div>
  )

  return (
    <div className={classes.root}>
      <AppBar position="static" color="inherit" elevation={0}>
        <Toolbar className={classes.toolbar}>
          <LogoData href={islogin ? '/dashboard' : '/'} />
          {!hideLogin && btnAction}
        </Toolbar>
      </AppBar>
    </div>
  )
}

export default withAppBarStyles(translate('common')(MUIAppBar))
